import React, { useState, useEffect } from "react";
import MQSGUtil from "../mqsgUtil";
import "./surveyPage.css";
import ReCAPTCHA from "react-google-recaptcha";
const SurveyPage = (props) => {
  const [tabIndex, setTabIndex] = useState(0);
  const [isNext, setIsNext] = useState(false);
  const [isSubmit, setIsSubmit] = useState(false);
  const [success, setISsuccess] = useState(false);
  const [SurveyPageData, setSurveyPageData] = useState([]);
  const [warning, setWarning] = useState("none");
  const [disclaimer, setDisclaimer] = useState("");
  const [completionText, setCompletionText] = useState("");
  const [boxTips, setBoxTips] = useState(false);
  const [imgs, setImgs] = useState({});
  const [email, setEmail] = useState("");
  const [binaryString, setBinaryString] = useState({});
  const [submitData, setSubmitData] = useState({
    tab: {
      id: 3,
      name: "Submit",
      sort: 3,
      update_time: "2024-09-04T03:01:03.000Z",
    },
    "questions": [{
      "id": 2,
      "name": "Name",
      "type": 2,
      "tab_id": "3",
      "tab_name": "Submit",
      "pre_answer_id": "0",
      "sort": 1,
      "update_time": "2024-09-12T07:22:35.000Z",
       "msg":'',
      "answers": []
    }, {
      "id": 3,
      "name": "Email address",
      "type": 2,
      "tab_id": "3",
      "tab_name": "Submit",
      "pre_answer_id": "0",
      "sort": 2,
      "update_time": "2024-09-12T07:23:45.000Z",
      "msg":'',
      "answers": []
    }

  ]
  });
  const recaptchaRef = React.createRef();
  useEffect(() => {
    window.scrollTo(0, 0);
    window.addEventListener("scroll", (e) => {
      if (document.body.clientWidth < 500) {
        if (window.scrollY > 110) {
          var _dom = document.getElementById("fixed");
          _dom.className = "SurveyPage_fixed";
        } else {
          var _dom = document.getElementById("fixed");
          _dom.className = "";
        }
      } else {
        var _dom = document.getElementById("fixed");
        _dom.className = "";
      }
    });
  }, []);
  const getSurveyPageData = async () => {
    const url = MQSGUtil.getAPIBasePath() + "/survey/page/text";
    fetch(url)
      .then((res) => res.json())
      .then((result) => {
        let SurveyPageData = result.data;
        let completion_text = result.completion_text;
        let disclaimer = result.disclaimer;
        setDisclaimer(disclaimer);
        setCompletionText(completion_text);
        var n = 1;
        for (let i = 0; i < SurveyPageData.length; i++) {
          for (let j = 0; j < SurveyPageData[i].questions.length; j++) {
            SurveyPageData[i].questions = SurveyPageData[i].questions.sort(
              (a, b) => a.sort - b.sort,
            );
            SurveyPageData[i].questions[j]["msg"] = "";
            if (SurveyPageData[i].questions[j].type == 3) {
              SurveyPageData[i].questions[j]["img_id"] = "image" + n;
              n++;
            }
            if (SurveyPageData[i].questions[j]["pre_answer_id"] == "0") {
              SurveyPageData[i].questions[j]["submit"] = true;
            } else {
              SurveyPageData[i].questions[j]["submit"] = false;
            }
            for (
              let y = 0;
              y < SurveyPageData[i].questions[j].answers.length;
              y++
            ) {
              SurveyPageData[i].questions[j].answers[y]["check"] = false;
              // if (SurveyPageData[i].questions[j].answers[y].name.toLowerCase() == 'other') {
              if (SurveyPageData[i].questions[j].answers[y].open_end == 1) {
                SurveyPageData[i].questions[j].answers[y]["msg"] = "";
              }
            }
          }
        }
        setSurveyPageData(SurveyPageData);
      });
  };
  const changeTab = (i) => {
    if (!isNext) {
      setTabIndex(i);
      window.scrollTo(0, 0);
    }
  };
  useEffect(() => {
    getSurveyPageData();
  }, []);
  const setAnswer = (tab, value, name, qIndex, wIndex) => {
    if (tab !== 100) {
      let NewData = [...SurveyPageData];
      if (name === "text") {
        NewData[tab].questions[qIndex]["answers"][wIndex]["msg"] = value;
      } else if (name === "textarea") {
        NewData[tab].questions[qIndex]["msg"] = value;
      } else if (name === "file") {
        // NewData[tab].questions[qIndex]['msg'] = value;
        let imgObject = value?.target?.files[0];
        if (imgObject === undefined) {
          NewData[tab].questions[qIndex]["msg"] = "";
        } else {
          NewData[tab].questions[qIndex]["msg"] =
            "{" + NewData[tab].questions[qIndex]["img_id"] + "}";
        }
        uploadTips(value, NewData[tab].questions[qIndex]["img_id"]);
      } else if (name === "radio") {
        let arr = NewData[tab].questions[qIndex]["answers"].forEach(
          (item, i) => {
            item.check = false;
          },
        );
        NewData[tab].questions[qIndex]["answers"][wIndex]["check"] =
          value.target.checked;
      } else if (name === "checkbox") {
        NewData[tab].questions[qIndex]["answers"][wIndex]["check"] =
          value.target.checked;
      }
      for (let j = 0; j < NewData.length; j++) {
        let dataArray = NewData[j].questions.forEach((item, i) => {
          let arr = NewData[tab].questions[qIndex]["answers"].forEach(
            (e, i) => {
              if (e.check === true) {
                if (e.id === item.pre_answer_id) {
                  item.submit = true;
                }
              } else {
                if (e.id === item.pre_answer_id) {
                  item["answers"].forEach((q, b) => {
                    q.check = false;
                  });
                  item.submit = false;
                  item.msg = "";
                }
              }
            },
          );
        });
      }
      setSurveyPageData(NewData);
    } else {
      if (qIndex === 1) {
        setEmail(value);
      }
      let NewData = { ...submitData };
      if (name === "text") {
        NewData.questions[qIndex]["answers"][wIndex]["msg"] = value;
      } else if (name === "textarea") {
        NewData.questions[qIndex]["msg"] = value;
      } else if (name === "radio") {
        let arr = NewData.questions[qIndex]["answers"].forEach((item, i) => {
          item.check = false;
        });
        NewData.questions[qIndex]["answers"][wIndex]["check"] =
          value.target.checked;
      } else if (name === "checkbox") {
        NewData.questions[qIndex]["answers"][wIndex]["check"] =
          value.target.checked;
      }
      setSubmitData(NewData);
    }
  };
  const imgTobinary = (file, id) => {
    const imgValue = binaryString;
    imgValue[id] = file;
    setBinaryString(imgValue);
  };
  const submit = async () => {
    let imgArr = [];
    for (var i in binaryString) {
      imgArr.push(binaryString[i]);
    }
    
    // 使用 React state 进行验证，而不是直接操作 DOM
    let validated = true;
    setWarning("inline-block");
    
    // 检查所有问题的 msg 字段是否为空
    for (let i = 0; i < SurveyPageData.length; i++) {
      for (let j = 0; j < SurveyPageData[i].questions.length; j++) {
        const question = SurveyPageData[i].questions[j];
        if (question.msg && question.msg.trim() !== "") {
          validated = false;
          break;
        }
        // 检查答案的 msg
        if (question.answers) {
          for (let k = 0; k < question.answers.length; k++) {
            if (question.answers[k].msg && question.answers[k].msg.trim() !== "") {
              validated = false;
              break;
            }
          }
        }
        if (!validated) break;
      }
      if (!validated) break;
    }
    
    // if(!isSubmit){
    //   setBoxTips(true)
    // }
    if (validated) {
      const token = await recaptchaRef.current.executeAsync();
      let data = new FormData();
      data.append("content", JSON.stringify([...SurveyPageData, submitData]));
      data.append("image1", binaryString?.image1);
      data.append("image2", binaryString?.image2);
      data.append("response", token);
      data.append("email", email);
      const options = {
        method: "POST",
        // headers: {
        //   'Content-Type': 'multipart/form-data',
        // },
        body: data,
      };
      const url = MQSGUtil.getAPIBasePath() + "/survey/result";
      // const url = "https://www.google.com/recaptcha/api/siteverify";
      fetch(url, options)
        .then((res) => res.json())
        .then((result) => {
          if (result.message == "succeed") {
            setIsNext(true);
            setISsuccess(true);
            setTabIndex(null);
            setBoxTips(false);
            window.scrollTo(0, 0);
          } else {
            alert(result.message);
          }
        });
    }
  };
  const changeSubmitValue = (v) => {
    setIsSubmit(v);
    setBoxTips(!v);
  };
  const getPlaceholder = (v) => {
    if (v.indexOf("Name") !== -1) {
      return "Firstname Lastname";
    } else if (v.indexOf("Email") !== -1) {
      return "abc@email.com";
    } else {
      return "000-000-0000";
    }
  };
  const getTips = (n, v) => {
    if (n.indexOf("Name") !== -1) {
      if (v.trim() !== "") {
        return "";
      } else {
        return "Please fill in.";
      }
    } else if (n.indexOf("Email") !== -1) {
      var emailPat = /^(.+)@(.+)$/;
      var matchArray = v.match(emailPat);
      if (matchArray) {
        return "";
      } else {
        return "Email is required. Please fill in.";
      }
    } else {
      if (v.trim() !== "") {
        return "";
      } else {
        return "Mobile is required. Please fill in.";
      }
    }
  };
  const onChange = (value) => {
    console.log("Captcha value:", value);
  };
  const uploadTips = (e, id) => {
    imgTobinary(e?.target?.files[0], id);
  };
  return (
    <div id="SurveyPage" className="pageobj" style={{}}>
      <div className="container-fluid">
        <div className="row">
          <div className="col-md-12" style={{ padding: "0px" }}>
            <div className="banner">
              <img src={MQSGUtil.getAPIBasePath() + "/photo?survey=1"} alt="" />
            </div>
          </div>
        </div>
        <div className="row" id="fixed" style={{ background: "#fff" }}>
          <div
            className="col-md-10"
            style={{ margin: "0 auto", float: "none" }}
          >
            <div
              className=""
              style={{
                margin: "0 auto",
                textAlign: "center",
                lineHeight: "45px",
                display: "flex",
              }}
            >
              {SurveyPageData.map((value, index) => {
                return (
                  <div
                    className={
                      tabIndex == index ? " nav_test nav_active" : " nav_test"
                    }
                    onClick={() => changeTab(index)}
                  >
                    {tabIndex == index ? (
                      <img
                        src="/img/home/circle.svg"
                        alt=""
                        className="nav_img"
                      />
                    ) : (
                      <img
                        src="/img/home/check2.svg"
                        alt=""
                        className="nav_img"
                      />
                    )}
                    <span>{value.tab.name}</span>
                  </div>
                );
              })}
              <div
                className={
                  tabIndex == SurveyPageData.length
                    ? " nav_test nav_active"
                    : " nav_test"
                }
                onClick={() => changeTab(SurveyPageData.length)}
              >
                {tabIndex == SurveyPageData.length ? (
                  <img src="/img/home/circle.svg" alt="" className="nav_img" />
                ) : (
                  <img src="/img/home/check2.svg" alt="" className="nav_img" />
                )}
                <span>Submit</span>
              </div>
            </div>
          </div>
        </div>
        {SurveyPageData.map((value, index) => {
          return (
            <div
              className="row"
              style={{ display: tabIndex == index ? "block" : "none" }}
            >
              <div className="col-md-12" style={{ background: "#fff" }}>
                <div className="section" style={{ marginTop: "0px" }}>
                  <div style={{ borderBottom: "1px solid #a9d1d3" }}>
                    {/* <p style={{ color: '#29949e', fontSize: '20px' }}>Please respond to each question as accurately as you can</p> */}
                    <h2>{value.tab.name}</h2>
                  </div>
                  {value.questions.map((d, i2) => {
                    return (
                      <div
                        style={{
                          borderBottom: "1px solid #a9d1d3",
                          padding: "25px 0px",
                          display: d.submit ? "block" : "none",
                        }}
                      >
                        <h4
                          style={{ color: "#666666" }}
                          dangerouslySetInnerHTML={{
                            __html: d.name,
                          }}
                        ></h4>
                        {d.type == 2 && (
                          <div>
                            <textarea
                              name="showText"
                              spellcheck="false"
                              rows="10"
                              placeholder="Your answer"
                              maxLength="3000"
                              value={d.msg}
                              onChange={(e) =>
                                setAnswer(index, e.target.value, "textarea", i2)
                              }
                              style={{ width: "100%" }}
                            ></textarea>
                            <p>{d.msg.length} of 3000 max characters</p>
                          </div>
                        )}
                        {d.type != 2 &&
                          d.answers.map((v, i3) => {
                            return (
                              <div
                                style={{
                                  margin: "5px 0px",
                                  fontSize: "18px",
                                  color: "#000",
                                }}
                              >
                                <input
                                  type={d.type == 0 ? "radio" : "checkbox"}
                                  checked={v.check ? "checked" : null}
                                  onChange={(e) => {
                                    setAnswer(
                                      index,
                                      e,
                                      d.type == 0 ? "radio" : "checkbox",
                                      i2,
                                      i3,
                                    );
                                  }}
                                  value={d.name}
                                  name={d.tab_name + i2}
                                />
                                &nbsp;
                                {v.name}
                                {v.open_end == 1 && v.check == true && (
                                  <div
                                    style={{
                                      marginLeft: "15px",
                                      marginTop: "5px",
                                    }}
                                  >
                                    {" "}
                                    <input
                                      type="text"
                                      value={v.msg}
                                      onChange={(e) =>
                                        setAnswer(
                                          index,
                                          e.target.value,
                                          "text",
                                          i2,
                                          i3,
                                        )
                                      }
                                      placeholder="Your answer"
                                      style={{ width: "30%", fontSize: "14px" }}
                                    />
                                  </div>
                                )}
                              </div>
                            );
                          })}
                        {d.type == 3 && (
                          <div>
                            <input
                              type="file"
                              id="imageInput"
                              accept="image/jpeg"
                              onChange={(e) => setAnswer(index, e, "file", i2)}
                            ></input>
                            <span>(jpg file only)</span>
                          </div>
                        )}
                      </div>
                    );
                  })}
                  <div>
                    <div style={{ marginTop: "10px" }}>
                      Note that the trade is subject to Macquarie Singapore
                      Warrant’s verification. For more information, please email{" "}
                      <a href="mailto:info@warrants.com.sg">
                        info@warrants.com.sg
                      </a>{" "}
                      or call +65 6601 0289. See disclaimer at{" "}
                      <a href="/about/disclaimer" target="_blank">
                        warrants.com.sg/about/disclaimer.{" "}
                      </a>
                      Macquarie reserves the rights of final decision which
                      shall be binding in all aspects.
                    </div>
                    {index != 0 && (
                      <input
                        type="button"
                        className="btn btn-primary"
                        value="Previous"
                        style={{ marginRight: "15px" }}
                        onClick={() => changeTab(index - 1)}
                      />
                    )}
                    <input
                      type="button"
                      className="btn btn-primary"
                      value="Next"
                      onClick={() => changeTab(index + 1)}
                    />
                  </div>
                </div>
              </div>
            </div>
          );
        })}
        <div
          className="row"
          style={{
            display: tabIndex == SurveyPageData.length ? "block" : "none",
          }}
        >
          <div className="col-md-12" style={{ background: "#fff" }}>
            <div className="section" style={{ marginTop: "0px" }}>
              <div style={{ borderBottom: "1px solid #a9d1d3" }}>
                <p style={{ color: "#29949e", fontSize: "20px" }}>
                  Please fill in the required information and submit
                </p>
                <h2>Your contact details</h2>
              </div>
              {submitData &&
                submitData.questions.map((d, index) => {
                  return (
                    <div
                      style={{
                        borderBottom: "1px solid #a9d1d3",
                        padding: "25px 0px",
                      }}
                    >
                      <h4 style={{ color: "#666666", fontWeight: "bold" }}>
                        {d.name}
                      </h4>
                      {d.type == 2 && (
                        <div>
                          <input
                            name="showText"
                            type="text"
                            rows="10"
                            placeholder={getPlaceholder(d.name)}
                            value={d.msg}
                            onChange={(e) =>
                              setAnswer(100, e.target.value, "textarea", index)
                            }
                            style={{ width: "40%" }}
                          ></input>
                          <span
                            style={{
                              marginLeft: "5px",
                              color: "red",
                              display: warning,
                            }}
                            className="warning"
                            name={getTips(d.name, d.msg)}
                          >
                            {getTips(d.name, d.msg)}
                          </span>
                        </div>
                      )}
                    </div>
                  );
                })}
              <div
                style={{
                  borderBottom: "1px solid #a9d1d3",
                  padding: "25px 0px",
                }}
              >
                <div
                  dangerouslySetInnerHTML={{ __html: disclaimer }}
                  style={{ marginTop: "10px" }}
                ></div>
                <div>
                  <input
                    type="button"
                    className="btn btn-primary"
                    value="Submit"
                    style={{
                      marginTop: "30px",
                      padding: "10px 20px",
                      fontSize: "25px",
                    }}
                    onClick={submit}
                  />
                </div>
              </div>
            </div>
            <div>
              <input
                type="button"
                className="btn btn-primary"
                value="Previous"
                onClick={() => changeTab(SurveyPageData.length - 1)}
              />
            </div>
          </div>
        </div>
        <div
          className="row"
          style={{ display: success == true ? "block" : "none" }}
        >
          <div
            className="col-md-12"
            style={{ background: "#fff", padding: "0px" }}
          >
            <div className="section">
              <div style={{ borderBottom: "1px solid #a9d1d3" }}>
                <p style={{ color: "#29949e", fontSize: "20px" }}>
                  Successfully submitted
                </p>
                <h2 style={{ fontWeight: "bold" }}>
                  Thank you for completing the survey!
                </h2>
              </div>
              <div
                dangerouslySetInnerHTML={{ __html: completionText }}
                style={{ marginTop: "10px" }}
              ></div>
            </div>
            <div style={{ background: "#a3d4d9" }}>
              <div style={{ padding: "20px 20px" }}>
                <span
                  style={{
                    color: "#004559",
                    fontSize: "20px",
                    fontWeight: "bold",
                  }}
                >
                  Follow our social medias{" "}
                </span>
                <span style={{ fontSize: "18px" }}>
                  to receive daily updates and insights on the warrants market,
                  and stay tuned for more exciting warrant contests!
                </span>
                <div className="sharebtns">
                  <a
                    target="_blank"
                    className="sharebtn-tl btn"
                    type="button"
                    href="https://t.me/MacquarieWarrantsSG"
                  ></a>
                  <a
                    target="_blank"
                    className="sharebtn-fb btn"
                    type="button"
                    href="https://www.facebook.com/MacquarieWarrantsSG/?utm_source=MQ&utm_medium=Icon&utm_campaign=FB"
                  ></a>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <ReCAPTCHA
        theme="dark"
        ref={recaptchaRef}
        size="invisible"
        sitekey={process.env.REACT_APP_RECAPTCHA_SITEKEY}
      ></ReCAPTCHA>
    </div>
  );
};
export default SurveyPage;
